import parse from "./parse/index.mjs";
const isEncoded = component => {
  try {
    return typeof component === 'string' && decodeURIComponent(component) !== component;
  } catch (e) {
    return false;
  }
};
export const encodePathComponent = component => {
  if (isEncoded(component)) {
    return component;
  }
  return encodeURIComponent(component);
};
const significantTypes = ['slash', 'path-literal', 'query-marker', 'query-literal', 'template-expression-param-name'];
const resolve = (pathTemplate, parameters = {}, options = {}) => {
  const defaultOptions = {
    encoder: encodePathComponent
  };
  const mergedOptions = {
    ...defaultOptions,
    ...options
  };
  const parseResult = parse(pathTemplate);
  if (!parseResult.result.success) return pathTemplate;
  const parts = [];
  parseResult.ast.translate(parts);
  const resolvedParts = parts.filter(([type]) => significantTypes.includes(type)).map(([type, value]) => {
    if (type === 'template-expression-param-name') {
      return Object.hasOwn(parameters, value) ? mergedOptions.encoder(parameters[value]) : `{${value}}`;
    }
    return value;
  });
  return resolvedParts.join('');
};
export default resolve;